/**
 * uiTokens.ts — UIクロームのデザイントークン
 *
 * ここで定義するのは「管理画面から指定されない」UI側の色・サイズのみ。
 * 車両タイプ・予約・ステータス・スタッフ等の bg_color / text_color は
 * データ（管理画面設定）由来なので、このトークンでは扱わない（温存する）。
 *
 * 方針: 無彩色は slate 系1系統に統一。アクセントは blue 1色。
 * 透過(rgba/opacity)での状態表現は使わず、事前計算した実色を使う。
 */

export const UI = {
  // 無彩色階調（slate）
  color: {
    text: '#0f172a',        // 主要テキスト
    textSub: '#475569',     // 補助テキスト
    textMuted: '#94a3b8',   // ヒント・無効
    border: '#e2e8f0',      // 標準罫線
    borderStrong: '#cbd5e1',// 強調罫線
    bgPage: '#f8fafc',      // ページ背景
    bgCard: '#ffffff',      // カード背景
    bgHover: '#f1f5f9',     // ホバー
    bgSubtle: '#f8fafc',    // サブゾーン等の薄背景
    accent: '#2563eb',      // アクセント（DnDホバー・フォーカス）
    accentBg: '#eff6ff',    // アクセント薄背景（ドロップ可能ハイライト）
    danger: '#d32f2f',      // 当日warning等（既存の意味色は踏襲）
  },
  // タイポグラフィ（5段階に集約）
  font: {
    xs: '0.6rem',   // メタ情報・カウント
    sm: '0.65rem',  // カード本文・タグ
    md: '0.75rem',  // カードタイトル・セル基本
    base: '0.85rem',// 見出し小・入力
    lg: '1rem',     // セクション見出し
  },
  // 角丸（2種類）
  radius: {
    sm: '4px',
    md: '8px',
  },
} as const;

export type UITokens = typeof UI;
